import { assert } from '@varos/util-typescript';
import { ChatItemAssistantTaskAggregate } from './chatAssistantTaskModel';
import { ReportingShellLoaderBaseConfig } from '../../../../base';
import { ChatItemAssistantTaskLoader } from './chatAssistantTaskInterface';

export function createChatItemAssistantTaskLoader(
    config: ReportingShellLoaderBaseConfig
): ChatItemAssistantTaskLoader {
    const {
        repository: { assistant: repository },
    } = config;
    return {
        useLoad(context, props): ChatItemAssistantTaskAggregate {
            const taskQuery = repository.task.useLookup(
                context,
                {
                    taskId: props.item.result?.workflow?.id!,
                },
                {
                    enabled: !!props.item.result?.workflow?.id,
                    refetchInterval(data, query) {
                        // only poll for statuses while task is still running
                        if (
                            !(
                                data?.status == 'running' ||
                                data?.status == 'pending'
                            )
                        ) {
                            return false;
                        }
                        return 5000;
                    },
                }
            );
            return {
                tool: props.item.tool,
                result: props.item.result,
                task: taskQuery.data ?? null,
            };
        },
    };
}
